export interface Movie {
  id: string;
  title: string;
  titleEn: string;
  year: number;
  category: string;
  rating: number;
  poster: string;
  description: string;
  director: string;
  actors: string[];
  duration: string;
  region: string;
  releaseDate: string;
  isNew: boolean;
  isHot: boolean;
  views: number;
  tags: string[];
}

export const categories = [
  { slug: 'all', name: '全部' },
  { slug: 'action', name: '动作片' },
  { slug: 'comedy', name: '喜剧片' },
  { slug: 'romance', name: '爱情片' },
  { slug: 'scifi', name: '科幻片' },
  { slug: 'horror', name: '恐怖片' },
  { slug: 'animation', name: '动画片' },
  { slug: 'crime', name: '犯罪片' },
  { slug: 'war', name: '战争片' },
  { slug: 'fantasy', name: '奇幻片' },
];

export const movies: Movie[] = [
  {
    id: '1',
    title: '逆战行动',
    titleEn: 'Operation Counterstrike',
    year: 2026,
    category: 'action',
    rating: 8.5,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20action%20movie%20poster%20with%20soldier%20holding%20weapon%20in%20urban%20combat%20scene%2C%20dramatic%20lighting%2C%20cinematic%20film%20poster%20style%2C%20dark%20moody%20background%2C%20golden%20and%20red%20color%20accents%2C%20professional%20movie%20poster%20design%20with%20Chinese%20typography%20aesthetic&width=400&height=560&seq=movie-poster-01&orientation=portrait',
    description: '一名退役特种兵在海外执行最后一次任务时，意外发现了一个国际恐怖组织的惊天阴谋。为了拯救无辜的生命，他必须重新拿起武器，与昔日的战友并肩作战，展开一场惊心动魄的逆战行动。',
    director: '林超贤',
    actors: ['张涵予', '彭于晏', '王千源', '黄景瑜'],
    duration: '128分钟',
    region: '中国大陆',
    releaseDate: '2026-07-15',
    isNew: true,
    isHot: true,
    views: 2856000,
    tags: ['动作', '战争', '军事'],
  },
  {
    id: '2',
    title: '星海迷踪',
    titleEn: 'Lost in Nebula',
    year: 2026,
    category: 'scifi',
    rating: 9.0,
    poster: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20sci-fi%20movie%20poster%20with%20astronaut%20floating%20in%20deep%20space%2C%20colorful%20nebula%20background%2C%20massive%20spaceship%2C%20cinematic%20film%20poster%20design%2C%20blue%20and%20purple%20cosmic%20colors%2C%20professional%20movie%20poster%20aesthetic&width=400&height=560&seq=movie-poster-02&orientation=portrait',
    description: '2150年，人类第一批星际移民舰队在穿越星云时遭遇未知能量波动，与地球失去联系。幸存的宇航员们必须在陌生的星系中寻找生存之道，同时揭开星海深处隐藏的古老秘密。',
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健', '赵今麦'],
    duration: '145分钟',
    region: '中国大陆',
    releaseDate: '2026-08-01',
    isNew: true,
    isHot: true,
    views: 4120000,
    tags: ['科幻', '太空', '冒险'],
  },
  {
    id: '3',
    title: '笑傲江湖之东方不败',
    titleEn: 'Swordsman: The East is Red',
    year: 2026,
    category: 'action',
    rating: 8.2,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20wuxia%20movie%20poster%20with%20warrior%20in%20red%20robes%20holding%20sword%20on%20mountain%20peak%2C%20dramatic%20sunset%20sky%2C%20flowing%20fabric%2C%20cinematic%20film%20poster%20style%2C%20traditional%20Chinese%20painting%20aesthetic%2C%20golden%20hour%20lighting&width=400&height=560&seq=movie-poster-03&orientation=portrait',
    description: '改编自金庸经典武侠小说，讲述令狐冲与东方不败之间恩怨情仇的故事。在江湖腥风血雨中，一段超越世俗的传奇情缘即将展开，刀光剑影间尽显武侠之美。',
    director: '徐克',
    actors: ['肖战', '杨紫', '张译', '倪妮'],
    duration: '135分钟',
    region: '中国香港',
    releaseDate: '2026-06-20',
    isNew: false,
    isHot: true,
    views: 3560000,
    tags: ['武侠', '古装', '爱情'],
  },
  {
    id: '4',
    title: '夏日恋爱手册',
    titleEn: 'Summer Love Handbook',
    year: 2026,
    category: 'romance',
    rating: 7.8,
    poster: 'https://readdy.ai/api/search-image?query=Romantic%20Chinese%20youth%20movie%20poster%20with%20young%20couple%20walking%20on%20beach%20at%20sunset%2C%20warm%20golden%20light%2C%20summer%20vibe%2C%20cinematic%20film%20poster%20style%2C%20soft%20pastel%20colors%2C%20dreamy%20atmosphere%2C%20professional%20movie%20poster%20design&width=400&height=560&seq=movie-poster-04&orientation=portrait',
    description: '一个关于青春与成长的故事。大学生林小夏在暑假实习期间遇到了高冷学长陆一鸣，两人从互相嫌弃到渐生情愫，经历了一系列啼笑皆非的故事后，最终找到了属于自己的爱情答案。',
    director: '陈可辛',
    actors: ['易烊千玺', '周也', '白敬亭', '章若楠'],
    duration: '118分钟',
    region: '中国大陆',
    releaseDate: '2026-07-28',
    isNew: true,
    isHot: false,
    views: 1890000,
    tags: ['爱情', '青春', '校园'],
  },
  {
    id: '5',
    title: '暗夜追踪',
    titleEn: 'Night Hunt',
    year: 2026,
    category: 'crime',
    rating: 8.7,
    poster: 'https://readdy.ai/api/search-image?query=Dark%20crime%20thriller%20movie%20poster%20with%20detective%20in%20rainy%20neon-lit%20city%20street%2C%20noir%20atmosphere%2C%20reflection%20on%20wet%20pavement%2C%20cinematic%20film%20poster%20style%2C%20red%20and%20black%20color%20palette%2C%20professional%20movie%20poster%20design&width=400&height=560&seq=movie-poster-05&orientation=portrait',
    description: '一位经验丰富的刑警在追捕连环杀手的过程中，发现案件背后隐藏着更大的阴谋。每一条线索都指向一个神秘的地下组织，而他必须在暗夜中与时间赛跑，阻止下一场悲剧的发生。',
    director: '陈思诚',
    actors: ['刘昊然', '王宝强', '肖央', '谭卓'],
    duration: '132分钟',
    region: '中国大陆',
    releaseDate: '2026-06-10',
    isNew: false,
    isHot: true,
    views: 2980000,
    tags: ['犯罪', '悬疑', '刑侦'],
  },
  {
    id: '6',
    title: '萌宠大冒险',
    titleEn: 'Pet Adventure',
    year: 2026,
    category: 'animation',
    rating: 8.0,
    poster: 'https://readdy.ai/api/search-image?query=Cute%20animated%20movie%20poster%20with%20adorable%20cartoon%20pets%20dog%20cat%20rabbit%20on%20epic%20adventure%2C%20colorful%20vibrant%20background%2C%20magical%20forest%20setting%2C%20cinematic%203D%20animation%20film%20poster%20style%2C%20warm%20and%20playful%20atmosphere&width=400&height=560&seq=movie-poster-06&orientation=portrait',
    description: '一只勇敢的小狗和它的萌宠朋友们踏上了寻找主人遗落宝物的奇妙旅程。一路上它们穿越森林、飞越峡谷，经历了无数冒险与挑战，最终明白了友情与勇气的真正含义。',
    director: '饺子',
    actors: ['沈腾', '马丽', '贾玲', '艾伦'],
    duration: '105分钟',
    region: '中国大陆',
    releaseDate: '2026-07-01',
    isNew: true,
    isHot: false,
    views: 1750000,
    tags: ['动画', '冒险', '喜剧'],
  },
  {
    id: '7',
    title: '午夜凶楼',
    titleEn: 'Midnight Tower',
    year: 2026,
    category: 'horror',
    rating: 7.5,
    poster: 'https://readdy.ai/api/search-image?query=Creepy%20horror%20movie%20poster%20with%20haunted%20apartment%20building%20at%20night%2C%20silhouette%20figure%20in%20window%2C%20eerie%20moonlight%2C%20dark%20atmospheric%20film%20poster%20style%2C%20cold%20blue%20and%20black%20tones%2C%20professional%20horror%20movie%20poster%20design&width=400&height=560&seq=movie-poster-07&orientation=portrait',
    description: '一群年轻人入住一栋传闻闹鬼的老旧公寓楼，午夜时分诡异事件接连发生。当他们试图逃离时，才发现这栋楼隐藏着一个不为人知的恐怖秘密，而他们已经成为了猎物。',
    director: '温子仁',
    actors: ['张子枫', '李现', '文咏珊', '朱一龙'],
    duration: '108分钟',
    region: '中国香港',
    releaseDate: '2026-05-18',
    isNew: false,
    isHot: false,
    views: 1560000,
    tags: ['恐怖', '惊悚', '悬疑'],
  },
  {
    id: '8',
    title: '代号：猎鹰',
    titleEn: 'Code: Falcon',
    year: 2026,
    category: 'war',
    rating: 8.3,
    poster: 'https://readdy.ai/api/search-image?query=Intense%20war%20movie%20poster%20with%20soldiers%20in%20battlefield%2C%20explosions%20and%20smoke%2C%20camouflage%20uniforms%2C%20dramatic%20cinematic%20lighting%2C%20military%20film%20poster%20style%2C%20olive%20green%20and%20orange%20color%20palette&width=400&height=560&seq=movie-poster-08&orientation=portrait',
    description: '根据真实事件改编，讲述中国维和部队在非洲执行任务时遭遇武装袭击，一支精锐小队临危受命，穿越敌占区营救被困同胞的故事。',
    director: '吴京',
    actors: ['吴京', '段奕宏', '张译', '杜江'],
    duration: '140分钟',
    region: '中国大陆',
    releaseDate: '2026-04-25',
    isNew: false,
    isHot: true,
    views: 5230000,
    tags: ['战争', '军事', '动作'],
  },
  {
    id: '9',
    title: '仙缘奇谭',
    titleEn: 'Tale of Immortals',
    year: 2026,
    category: 'fantasy',
    rating: 7.9,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20xianxia%20movie%20poster%20with%20immortal%20cultivator%20flying%20among%20floating%20mountains%2C%20magical%20glowing%20effects%2C%20ancient%20Chinese%20palace%20in%20clouds%2C%20cinematic%20film%20poster%20style%2C%20ethereal%20misty%20atmosphere%2C%20jade%20and%20gold%20color%20scheme&width=400&height=560&seq=movie-poster-09&orientation=portrait',
    description: '在一个灵气复苏的仙侠世界中，少年楚云意外获得上古仙器，踏上修仙之路。他历经磨难，结识挚友，最终在正邪大战中成长为一代仙尊，守护天下苍生。',
    director: '乌尔善',
    actors: ['王一博', '赵丽颖', '胡歌', '刘亦菲'],
    duration: '142分钟',
    region: '中国大陆',
    releaseDate: '2026-06-05',
    isNew: false,
    isHot: false,
    views: 2130000,
    tags: ['奇幻', '仙侠', '古装'],
  },
  {
    id: '10',
    title: '厨神争霸',
    titleEn: 'Battle of Chefs',
    year: 2026,
    category: 'comedy',
    rating: 7.6,
    poster: 'https://readdy.ai/api/search-image?query=Funny%20Chinese%20food%20comedy%20movie%20poster%20with%20chefs%20cooking%20in%20kitchen%2C%20colorful%20delicious%20dishes%2C%20comedic%20expressions%2C%20warm%20restaurant%20lighting%2C%20cinematic%20film%20poster%20style%2C%20vibrant%20food%20colors&width=400&height=560&seq=movie-poster-10&orientation=portrait',
    description: '一位米其林三星大厨因意外穿越到古代，凭借现代厨艺在古代厨艺大赛中一鸣惊人。他用一道道令人惊艳的美食征服了古代人的味蕾，也收获了一段奇妙的爱情。',
    director: '周星驰',
    actors: ['黄渤', '沈腾', '贾玲', '徐峥'],
    duration: '115分钟',
    region: '中国大陆',
    releaseDate: '2026-07-10',
    isNew: true,
    isHot: false,
    views: 1680000,
    tags: ['喜剧', '美食', '穿越'],
  },
  {
    id: '11',
    title: '深海危机',
    titleEn: 'Deep Sea Crisis',
    year: 2026,
    category: 'scifi',
    rating: 8.1,
    poster: 'https://readdy.ai/api/search-image?query=Underwater%20thriller%20movie%20poster%20with%20submarine%20and%20deep%20sea%20creatures%2C%20dark%20ocean%20depths%2C%20bioluminescent%20glow%2C%20cinematic%20film%20poster%20style%2C%20deep%20blue%20and%20teal%20colors%2C%20professional%20movie%20poster%20design&width=400&height=560&seq=movie-poster-11&orientation=portrait',
    description: '深海科考队在万米海沟发现神秘生物信号，当他们驾驶深潜器前往探索时，遭遇了一系列无法解释的超自然现象。海底深处，隐藏着一个足以改变人类认知的巨大秘密。',
    director: '路阳',
    actors: ['黄轩', '杨幂', '雷佳音', '张颂文'],
    duration: '138分钟',
    region: '中国大陆',
    releaseDate: '2026-05-30',
    isNew: false,
    isHot: false,
    views: 1920000,
    tags: ['科幻', '惊悚', '冒险'],
  },
  {
    id: '12',
    title: '老爸是超人',
    titleEn: 'My Dad is Superman',
    year: 2026,
    category: 'comedy',
    rating: 7.3,
    poster: 'https://readdy.ai/api/search-image?query=Heartwarming%20family%20comedy%20movie%20poster%20with%20father%20and%20child%20in%20superhero%20costumes%2C%20funny%20home%20scene%2C%20bright%20sunny%20lighting%2C%20cinematic%20film%20poster%20style%2C%20warm%20yellow%20and%20red%20color%20scheme&width=400&height=560&seq=movie-poster-12&orientation=portrait',
    description: '一个普通的上班族老爸为了在女儿心中树立英雄形象，谎称自己是超人。没想到女儿信以为真，还帮他在学校报名了超级英雄展示日。一场充满欢笑与温情的闹剧就此展开。',
    director: '闫非',
    actors: ['沈腾', '张子枫', '田雨', '魏翔'],
    duration: '110分钟',
    region: '中国大陆',
    releaseDate: '2026-06-15',
    isNew: false,
    isHot: false,
    views: 1340000,
    tags: ['喜剧', '家庭', '温馨'],
  },
];

export const featuredMovies = movies.filter(m => m.isNew).slice(0, 6);
export const hotMovies = movies.filter(m => m.isHot).slice(0, 6);
export const topRatedMovies = [...movies].sort((a, b) => b.rating - a.rating).slice(0, 10);

export function getMoviesByCategory(slug: string): Movie[] {
  if (slug === 'all') return movies;
  return movies.filter(m => m.category === slug);
}

export function getMovieById(id: string): Movie | undefined {
  return movies.find(m => m.id === id);
}

export function getRelatedMovies(movie: Movie, count: number = 4): Movie[] {
  return movies
    .filter(m => m.id !== movie.id && m.category === movie.category)
    .slice(0, count);
}